import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import BookRidePage from "./pages/BookRidePage";
import ContactPage from "./pages/ContactPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import CustomerLoginPage from "./pages/CustomerLoginPage";
import CustomerDashboard from "./pages/CustomerDashboard";
import DullesAirportPage from "./pages/DullesAirportPage";
import ReaganAirportPage from "./pages/ReaganAirportPage";
import CorporateNoVAPage from "./pages/CorporateNoVAPage";
import ArlingtonPage from "./pages/ArlingtonPage";
import TysonsPage from "./pages/TysonsPage";

// Scroll to top or anchor component
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  
  useEffect(() => {
    if (hash) {
      // Wait for DOM to render, then scroll to anchor
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  
  return null;
};

// Layout with Header and Footer
const MainLayout = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
  </>
);

// Portal Layout without Header/Footer
const PortalLayout = ({ children }) => (
  <main>{children}</main>
);

function App() {
  return (
    <HelmetProvider>
    <div className="App min-h-screen bg-[#050505]">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Admin Routes - No Header/Footer */}
          <Route path="/admin" element={<PortalLayout><AdminLoginPage /></PortalLayout>} />
          <Route path="/admin/dashboard" element={<PortalLayout><AdminDashboard /></PortalLayout>} />
          
          {/* Customer Portal Routes - No Header/Footer */}
          <Route path="/portal" element={<PortalLayout><CustomerLoginPage /></PortalLayout>} />
          <Route path="/portal/dashboard" element={<PortalLayout><CustomerDashboard /></PortalLayout>} />
          
          {/* Main Routes - With Header/Footer */}
          <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
          <Route path="/about" element={<MainLayout><AboutPage /></MainLayout>} />
          <Route path="/services" element={<MainLayout><ServicesPage /></MainLayout>} />
          <Route path="/book" element={<MainLayout><BookRidePage /></MainLayout>} />
          <Route path="/contact" element={<MainLayout><ContactPage /></MainLayout>} />
          
          {/* SEO Landing Pages */}
          <Route path="/dulles-airport-car-service" element={<MainLayout><DullesAirportPage /></MainLayout>} />
          <Route path="/reagan-airport-car-service" element={<MainLayout><ReaganAirportPage /></MainLayout>} />
          <Route path="/corporate-chauffeur-northern-virginia" element={<MainLayout><CorporateNoVAPage /></MainLayout>} />
          <Route path="/black-car-service-arlington" element={<MainLayout><ArlingtonPage /></MainLayout>} />
          <Route path="/black-car-service-tysons" element={<MainLayout><TysonsPage /></MainLayout>} />
        </Routes>
        <Toaster 
          position="top-right"
          toastOptions={{
            style: {
              background: '#0A0A0A',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#F5F5F5',
            },
          }}
        />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
